import { PAYMENT_MULTI_STEPS } from '../../utils/steps';
import { StepPerformanceWrapper } from '../atoms/step-performance-wrapper';
import { CareCreditPreapprovedDisclosureNavigationSwitch } from './care-credit-preapproved-disclosure/care-credit-preapproved-disclosure-navigation-switch';

export const CareCreditPreapprovedDisclosure = () => {
  return (
    <StepPerformanceWrapper step={PAYMENT_MULTI_STEPS.careCreditPreapprovedDisclosure}>
      <CareCreditPreapprovedDisclosureNavigationSwitch />
    </StepPerformanceWrapper>
  );
};
